import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from './../../../shared/services/courier.service';
import { GetRulesRequest, GetRulesResponse } from './../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'rule-check.component.html',
  styleUrls: ['./rule-check.component.scss']
})
export class RuleCheckComponent implements OnInit {
  rulesResponse: GetRulesResponse | null = null;
  loading: boolean = true;
  accepted: boolean = false;
  accordionSelectedItems: any[] = [];
  flag: boolean = true;

  constructor(
    public activeUserLocalDataService: ActiveUserLocalDataService,
    private courierService: CourierService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.loadRules();
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    this.accepted = startNewVoucherData?.rulesAccepted || false;
  }

  loadRules() {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (!startNewVoucherData) {
      this.router.navigate(['/pick-car']);
      return;
    }
    startNewVoucherData.rulesAccepted = false;
    const request: GetRulesRequest = { carId: startNewVoucherData.carId };
    this.courierService.getRules(request).subscribe((response: GetRulesResponse) => {
      this.rulesResponse = response;
      if (!response.rules || response.rules.length === 0) {
        this.router.navigate(['/pick-client']);
      } else {
        this.accordionSelectedItems = response.rules.map(rule => rule);
        this.loading = false;
      }
    });
  }

  navigateToClient() {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData?.rulesAccepted) {
      this.router.navigate(['/pick-client']);
    }
  }

  navigateToPickCar() {
    this.router.navigate(['/pick-car']);
  }

  onContentReady(e: any) {
    if (this.flag && this.rulesResponse?.rules) {
      for (let i = 0; i < this.rulesResponse.rules.length; i++) {
        e.component.expandItem(i);
      }
      this.flag = false;
    }
  }

  onCheckboxChange() {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData) {
      startNewVoucherData.rulesAccepted = this.accepted;
      this.activeUserLocalDataService.setStartNewVoucherData(startNewVoucherData);
    }
  }
}